import type { HTMLAttributes } from 'react';

import { cn } from '../lib/cn.js';

/** Raised surface. One elevation only — a second competes with the first. */
export const Card = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>): React.JSX.Element => (
  <div
    className={cn('rounded-lg border bg-card text-card-foreground shadow-sm', className)}
    {...props}
  />
);

export const CardHeader = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>): React.JSX.Element => (
  <div className={cn('flex flex-col gap-1 border-b px-5 py-4', className)} {...props} />
);

export const CardTitle = ({
  className,
  ...props
}: HTMLAttributes<HTMLHeadingElement>): React.JSX.Element => (
  <h2 className={cn('text-sm font-semibold tracking-tight', className)} {...props} />
);

export const CardDescription = ({
  className,
  ...props
}: HTMLAttributes<HTMLParagraphElement>): React.JSX.Element => (
  <p className={cn('text-sm text-muted-foreground', className)} {...props} />
);

export const CardContent = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>): React.JSX.Element => (
  <div className={cn('p-5', className)} {...props} />
);
